import React from 'react';
import classnames from 'classnames';
import { Link } from 'react-router';
import giftboxIcon from 'assets/svg/giftbox.svg';
import { APP_ROUTES } from 'swag-client-common/constants/app-routes';
import classes from './build-box-widget.scss';
export default function BuildBoxWidget({
  className,
  isShown = true,
  learnMoreTarget = undefined
}) {
  if (!isShown) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.widget, className)
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.iconWrapper
  }, /*#__PURE__*/React.createElement("img", {
    src: giftboxIcon,
    className: classes.icon
  })), /*#__PURE__*/React.createElement("p", {
    className: classes.title
  }, "Send Fully Custom Branded Boxes"), /*#__PURE__*/React.createElement("div", {
    className: classes.divider
  }), /*#__PURE__*/React.createElement("p", {
    className: classes.text
  }, "Show your employees and customers some love. Send them the good stuff in a box!", ' ', /*#__PURE__*/React.createElement(Link, {
    target: learnMoreTarget,
    className: classnames(classes.link),
    to: `${APP_ROUTES.IN_A_BOX}?utm_campaign=Swag%20in%20a%20box&utm_source=Homepage&utm_medium=Widget`
  }, "Learn more")));
}